// components/ReusableDonutChart.js
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
  } from "chart.js";
  import { Doughnut } from "react-chartjs-2";
  import "../../index.css";
  
  ChartJS.register(ArcElement, Tooltip, Legend);
  
  const DonutChart = ({
    labels = [],
    values = [],
    backgroundColors = [],
    currency = "ر.س"
  }) => {
    const data = {
      labels: labels.length
        ? labels
        : ["سندات صرف عامة", "سندات صرف صيانة", "سندات صرف فنية", "أخرى"],
      datasets: [
        {
          label: "البيانات",
          data: values.length ? values : [30, 35, 12, 20],
          backgroundColor: backgroundColors.length
            ? backgroundColors
            : ["#BB7A1F", "#699441", "#2484A4", "#E0E0E0"],
          hoverOffset: 8,
          borderWidth: 0
        }
      ]
    };
  
    const options = {
      cutout: "60%",
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              let label = context.label || "";
              let value = context.raw || 0;
              return `${label}: ${value.toLocaleString()} ${currency}`;
            }
          }
        }
      }
    };
  
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <Doughnut data={data} options={options} />
      </div>
    );
  };
  
  export default DonutChart;
  
